export default {
  namespaced: true,
  state () {
    return {
      layout: 'app-layout-default'
    }
  },
  getters: {
    layout (state) {
      return state.layout
    }
  },
  mutations: {
    applyLayout (state, layout) {
      state.layout = layout
    }
  },
  actions: {
    applyLayout ({ commit }, layout) {
      commit('applyLayout', layout)
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/store/layout.js